import { FC } from "react";
import { Select } from "antd";
import cn from "classnames";
import { useTranslation } from "react-i18next";
import { track } from "@amplitude/analytics-browser";
import { MdGridView } from "react-icons/md";
import { CorrectIcon } from "@Icons/MainIcons";
import { getAvatarColor } from "./CategoriesField.mob";

type CategoriesFieldWebProps = {
  value?: string;
  onChange?: (value: string) => void;
  options: { label: string; value: string }[];
  isFetching: boolean;
};

const CategoriesFieldWeb: FC<CategoriesFieldWebProps> = ({ value, onChange, options, isFetching }) => {
  const { t } = useTranslation();

  return (
    <Select
      value={value || undefined}
      placeholder={t("Giftcards.category")}
      options={options}
      loading={isFetching}
      popupMatchSelectWidth={false}
      onChange={(newValue: string) => {
        track("Category Selected", options.find((option) => option.value === newValue));
        onChange?.(newValue);
      }}
      variant="borderless"
      className="min-w-36"
      virtual={false}
      classNames={{
        root: "bg-background-default! rounded-xs! h-13! px-6! py-2! capitalize",
        popup: { root: "categories-field-popup custom-scrollbar w-80! p-3! rounded-xs!", listItem: "rounded-md! p-3!" },
      }}
      optionRender={(option) => {
        const optionValue = String(option.value ?? "");
        const isSelected = optionValue === (value ?? "");
        const isAll = optionValue === "";
        return (
          <div className="flex items-center gap-3">
            <div
              className={cn(
                "flex h-9 w-9 shrink-0 items-center justify-center rounded-sm text-sm font-semibold uppercase",
                isAll ? "bg-background-primary text-white" : getAvatarColor(optionValue),
              )}
            >
              {isAll ? <MdGridView className="h-4 w-4" /> : String(option.label).charAt(0)}
            </div>
            <span className={cn("text-font-default flex-1 truncate text-sm capitalize", isSelected ? "font-semibold" : "font-medium")}>{option.label}</span>
            {isSelected ? (
              <CorrectIcon className="text-font-active h-5 w-5 shrink-0" />
            ) : (
              <div className="border-border-default h-5 w-5 shrink-0 rounded-full border-2" />
            )}
          </div>
        );
      }}
    />
  );
};

export default CategoriesFieldWeb;
